import type { ExplorerFormat, SalesExplorerFilters } from "./types";

export function hasAppointmentFilter(filters: SalesExplorerFilters): boolean {
  return (
    filters.appointmentTypeIds.length > 0 ||
    filters.appointmentStatuses.length > 0 ||
    filters.professionalIds.length > 0 ||
    filters.financialStatus !== "all" ||
    filters.itemCount !== null
  );
}

export function hasItemFilter(filters: SalesExplorerFilters): boolean {
  return filters.itemIds.length > 0 || filters.itemTypes.length > 0 || filters.categoryIds.length > 0;
}

/**
 * Regra da spec: filtrou algo de atendimento -> a linha é o atendimento.
 * Só filtro de item -> a linha é o item vendido. Nenhum dos dois -> atendimento.
 * Filtros de pet e responsável apenas recortam; não mudam o formato.
 *
 * Precisa espelhar a decisão feita dentro de search_sales_explorer, que é a
 * autoridade — o front usa isto só para antecipar rótulos antes da resposta.
 */
export function resolveExplorerFormat(filters: SalesExplorerFilters): ExplorerFormat {
  if (!hasAppointmentFilter(filters) && hasItemFilter(filters)) return "item";
  return "appointment";
}
